// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2lgdB","notes":"Notes_notes__3Xu19","note":"Notes_note__1syQc","markdown":"Notes_markdown__y2JKf"};